import { PickSessionStrategy } from "@redotech/redo-fulfillment-wms-common/pick-session-enums";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getPickSessionFillCandidates = {
  name: "getPickSessionFillCandidates" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    strategy: createEnum(PickSessionStrategy),
    viewId: z.string().nullish(),
    excludeGroupIds: z.array(zExt.objectId()).max(100),
    count: z.number().int().min(1).max(100),
    merchantTimezone: z.string().optional(),
  }),
  output: z.object({
    viewId: z.string().nullable(),
    groups: z.array(
      z.object({ groupId: zExt.objectId(), orderNames: z.array(z.string()) }),
    ),
  }),
};
